type SkeletonTextVariant = 'text' | 'heading' | 'subheading';

interface ISkeletonTextProps {
  lines?: number;
  variant?: SkeletonTextVariant;
  width?: number;
}

export const SkeletonText = ({ lines = 1, variant = 'text', width = 0 }: ISkeletonTextProps) => {
  const className = variant === 'heading' ? 'h-6' : 'h-4';

  const pulseLines = [];
  for (let i = 0; i < lines; i++) {
    pulseLines.push(
      <span key={i} className={`block ${className} bg-muted animate-pulse`} style={width > 0 ? { width: `${width}px` } : {}}></span>
    );
  }
  return (
    <div className="flex-grow pt-1 pb-1 space-y-2" aria-hidden="true">
      {pulseLines}
    </div>
  );
};
